<template>
  <el-dialog
    @open="onOpen"
    title="Relatórios de Imoveis - Aluguel"
    :visible.sync="visibility"
    :before-close="fechar"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    width="46%"
  >
    <el-form
      :model="relatorio"
      ref="form"
      size="small"
      label-position="top"
      hide-required-asterisk
      :show-message="false"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Relatório" style="font-weight: bold;">
            <el-select
              auto-complete="off"
              v-model="relatorio.nome"
              @change="limparFiltros"
              clearable
              placeholder
              style="width: 100%;"
            >
              <el-option
                v-for="item in tiposRelatorios"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" style="padding: 10px 0px 10px 0px">
        <el-col :span="24">
          <el-radio v-model="relatorio.xls" :label="false">PDF</el-radio>
          <el-radio v-model="relatorio.xls" :label="true">Excel</el-radio>
        </el-col>
      </el-row>

      <el-row :span="24" v-if="exibirTipoImovel">
        <el-form-item label="Tipo" style="width: 100%; font-weight: bold;" prop="tipoImovel">
          <el-select
            v-model="relatorio.tipoImovel"
            value-key="id"
            placeholder=""
            reserve-keyword
            style="width: 100%">
            <el-option key="Todos" label="Todos" :value="undefined"/>
            <el-option
              v-for="item in tiposImoveis"
              :key="item.id"
              :label="item.nome"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-row>

      <el-row :gutter="10" v-if="exibirFiltroDataPlaca">
        <el-col :span="16" :md="24">
          <el-form-item label="Pesquisar por Data de:" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.dataPlaca" style="font-size: small;">
              <el-radio label="CAPTACAO" style="margin-top:5px">Captação do Imóvel</el-radio>
              <el-radio label="COLOCACAO" style="margin-top:5px" v-if="exibirDataColocacaoPlaca">Instalação da Placa</el-radio>
              <el-radio label="RETIRADA" style="margin-top:5px" v-if="exibirDataColocacaoPlaca">Retirada da Placa</el-radio>
              <el-radio label="SEM_FILTRO" style="margin-top:5px">Não Filtrar</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <span v-if="exibirStatusPlaca" style="font-weight: bold;">Status da Placa</span>
      <el-row :gutter="24" v-if="exibirStatusPlaca">
        <el-col :span="24" style="display: block;">
            <el-checkbox v-model="selecionarTodosPlacas" @change="alterarStatusTodosPlacas">Todos</el-checkbox>
            <el-checkbox-group v-model="relatorio.statusSelecionadosPlaca" class="radio-align-column">              
              <el-checkbox v-for="item in opcoesStatusPlacas" 
              :key="item.data"
              :label="item.data"
              >
              {{item.label}}
              </el-checkbox>
            </el-checkbox-group>
        </el-col>
      </el-row>
      <span v-if="exibirPeriodo" style="color: black;">{{labelPeriodo}}
      </span>
      <el-row v-if="exibirPeriodo" :gutter="24">
        <el-col :span="12">
          <el-form-item prop="dataInicial">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="dataFinal">
            <el-date-picker
              v-model="relatorio.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :span="24" v-if="exibirFaxaDiasFiltro">
        <el-form-item label="Faixa: " style="width: 100%; font-weight: bold;">
          <el-select
            v-model="relatorio.faixaDias"
            placeholder="Selecione uma faixa"
            style="width: 100%">
            <el-option
              v-for="item in opcoesFaixasDias"
              :key="item.data"
              :label="item.label"
              :value="item.data">
            </el-option>
          </el-select>
        </el-form-item>
      </el-row>

      <el-row :gutter="10" v-if="isVisibleFiltroValor">
        <el-col :span="6">
          <el-form-item label="Valor Inicial" style="font-weight: bold">
            <div class="el-input el-input--small">
              <money v-model="relatorio.valorInicial" v-bind="money" class="el-input__inner"/>
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="Valor Final" style="font-weight: bold">
            <div class="el-input el-input--small">
              <money v-model="relatorio.valorFinal" v-bind="money" class="el-input__inner"/>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <!--
      <el-row :gutter="10" v-if="exibirStatus">
        <el-col :span="16" :md="24">
          <el-form-item label="Status" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="" style="font-size: small;">
              <el-radio label="TODOS" style="margin-top:5px">Todos</el-radio><br/>
              <el-radio label="DISPONIVEL" style="margin-top:5px">Disponível</el-radio><br/>
              <el-radio label="RESERVADO" style="margin-top:5px">Reservado</el-radio><br/>
              <el-radio label="INDISPONIVEL" style="margin-top:5px">Indisponível</el-radio><br/>
              <el-radio label="LOCADO" style="margin-top:5px">Locado</el-radio><br/>
              <el-radio label="EM_DESOCUPACAO" style="margin-top:5px">Em Desocupação</el-radio><br/>
              <el-radio label="ARQUIVADO" style="margin-top:5px">Arquivado</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      -->
      <el-row :gutter="20" v-if="exibirCliente">
        <el-col :span="24">
          <el-form-item label="Proprietário" style="width: 100%;font-weight: bold;">
              <el-select v-model="relatorio.cliente"
              :remote-method="filtrarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder=""
              loading-text="Carregando Proprietários"
              no-data-text="Nenhum Proprietário Encontrado"
              filterable
              clearable
              @clear="relatorio.cliente = {id:0}"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                  v-for="item in clientesDisponiveis"
                  :key="item.id"
                  :label="formatarSelectCliente(item)"
                  :value="item">
              </el-option>
              </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirEstadoCidadeBairro">
        <el-col :span="2" :md="5">
          <el-form-item label="Estado" prop="estado" style="font-weight: bold;">
            <el-select v-model="relatorio.estado"
                value-key="id"
                placeholder=""
                filterable
                default-first-option
                style="width: 100%">
              <el-option v-for="item in estados" :key="item.id" :label="item.sigla" :value="item"/>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="7" :md="9">
          <el-form-item label="Cidade" prop="cidade" style="font-weight: bold;">
            <el-select
              v-model="relatorio.cidade"
              :remote-method="recuperarCidadesSelect"
              :loading="loadingCidades"
              value-key="id"
              placeholder=""
              loading-text="Carregando cidades"
              no-data-text="Nenhuma cidade encontrada"
              filterable
              remote
              default-first-option
              style="width: 100%">
                <el-option
                  v-for="item in cidadesDisponiveis"
                  :key="item.id"
                  :label="item.nome"
                  :value="item">
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="7" :md="10">
          <el-form-item label="Bairro" prop="bairro" style="font-weight: bold;">
            <el-select
              v-model="relatorio.bairro"
              :remote-method="recuperarBairrosSelect"
              :loading="loadingBairros"
              value-key="id"
              placeholder=""
              loading-text="Carregando bairros"
              no-data-text="Nenhum bairro encontrado"
              filterable
              remote
              default-first-option
              style="width: 100%">
                <el-option v-for="item in bairrosDisponiveis" :key="item.id" :label="item.nome" :value="item"/>
              </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirAdministradora">
        <el-col :span="16" :md="24">
          <el-form-item label="Administradora" style="width: 100%;font-weight: bold;">
            <el-select
              v-model="relatorio.administradora"
              :remote-method="recuperarAdministradorasSelect"
              :loading="loadingAdministradoras"
              value-key="id"
              placeholder=""
              loading-text="Carregando Administradoras"
              no-data-text="Nenhum Administradora encontrado"
              filterable
              clearable
              @clear="relatorio.administradora = undefined"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in administradorasDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirEdificioCondominio">
        <el-col :span="16" :md="24">
          <el-form-item label="Edifício/Condomínio" style="width: 100%;font-weight: bold;">
            <el-select
              v-model="relatorio.condominio"
              :remote-method="recuperarCondominiosSelect"
              :loading="loadingCondominios"
              value-key="id"
              placeholder=""
              loading-text="Carregando Condomínios"
              no-data-text="Nenhum Condomínio encontrado"
              filterable
              clearable
              @clear="relatorio.condominio = undefined"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in condominiosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" v-if="exibirTipoVistoria">
          <el-form-item label="Tipo de Vistoria">
            <el-select
              v-model="relatorio.tipoVistoria"
              value-key="id"
              placeholder=""
              reserve-keyword
              style="width: 100%;"
            >
              <el-option key="Todos" label="Todos" :value="undefined"/>
              <el-option 
                v-for="item in tiposVistoria"
                :key="item.id"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="exibirStatusVistoria">
          <el-form-item label="Status Vistoria">
            <el-select
              v-model="relatorio.statusVistoria"
              value-key="id"
              placeholder=""
              reserve-keyword
              style="width: 100%;"
            >
              <el-option key="Todos" label="Todos" :value="undefined"/>
              <el-option
                v-for="item in statusVistoria"
                :key="item.id"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" v-if="exibirDataAgendamento">
          <el-form-item label="Data de Agendamento">
            <el-date-picker
              v-model="relatorio.dataAgendamento"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="exibirDataConclusao">
          <el-form-item label="Data de Conclusão">
            <el-date-picker
              v-model="relatorio.dataConclusao"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-if="exibirCorretor">
        <el-col :span="24">
          <el-form-item :label="this.relatorio.nome === 'VISTORIAS_POR_PERIODO' ? 'Vistoriador' : 'Corretor'" style="width: 100%;font-weight: bold;">
            <el-select
              v-model="relatorio.usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              @focus="filtrarUsuariosSelect"
              value-key="id"
              placeholder=""
              loading-text="Carregando Usuários"
              no-data-text="Nenhum Usuário Encontrado"
              filterable
              clearable
              @clear="relatorio.usuario = {id:0}"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <span v-if="exibirStatus" style="font-weight: bold;">Status</span>
      <el-row :gutter="24" v-if="exibirStatus">
        <el-col :span="6" style="display: block;">
            <el-checkbox v-model="selecionarTodos" @change="alterarStatusTodos">Todos</el-checkbox>
            <el-checkbox-group v-model="relatorio.statusSelecionadosImovel" class="radio-align-column">              
              <el-checkbox v-for="item in opcoesStatusImoveis" 
              :key="item.data"
              :label="item.data"
              >
              {{item.label}}
              </el-checkbox>
            </el-checkbox-group>
        </el-col>
      </el-row>
      <el-row :gutter="14" v-if="exibirDiasCadastrado" style="margin-top: 15px;">
        <el-col :span="8">
          <el-form-item label="Dias Cadastrado" prop="diasCadastrado" style="width: 100%;font-weight: bold;">
            <el-input v-model="relatorio.diasCadastrado" v-mask="'##'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button type="primary" size="small" @click="gerarRelatorioHandler" round class="btn-box-shadow">Gerar Relatório</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Money } from "v-money";

import { mapState, mapActions } from "vuex";

import funcoes from "../../../util/funcoes.js";
import { TIPOS_IMOVEIS, ESTADOS, TIPO_VISTORIA, STATUS_VISTORIA } from "../../../util/constantes.js";

export default {
  props: {
    visibility: Boolean
  },

  components: {
    Money,
  },

  data() {
    return {
      tiposRelatorios: [],
      relatorio: {
        nome: undefined,
        usuario: {
          perfil: undefined
        },
        modulo: 'ALUGUEL',
        statusSelecionadosImovel: ['DISPONIVEL'],
        tipoImovel: undefined,
        valorInicial: 0,
        valorFinal: 0,
        cliente: {id: 0},
        imovel: { operacao: 'ALUGUEL' },
        estado: {id: 0},
        cidade: {id: 0},
        bairro: {id: 0},
        xls: false,
        administradora: undefined,
        condominio: undefined,
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),

        dataPlaca: 'CAPTACAO',
        statusSelecionadosPlaca: ['COLOCADA'],
        tipoDataVistoria: 'TODAS'
      },

      selecionarTodosPlacas: false,

      filtroDataCaptacao: true,
      loadingUsuarios: false,
      loadingClientes: false,
      loadingImoveis: false,
      loadingAdministradoras: false,
      loadingCondominios: false,
      loadingCidades: false,
      loadingBairros: false,

      administradorasDisponiveis: [],
      condominiosDisponiveis: [],
      cidadesDisponiveis: [],
      bairrosDisponiveis: [],

      opcoesFaixasDias: [
        {label: "Todos", data: undefined},
        {label: "0 a 30 dias", data: "ATE_30"},
        {label: "31 a 60 dias", data: "DE_31_A_60"},
        {label: "61 a 90 dias", data: "DE_61_A_90"},
        {label: "91 a 120 dias", data: "DE_91_A_120"},
        {label: "121 a 180 dias", data: "DE_121_A_180"},
        {label: "181 dias ou mais", data: "MAIOR_180"}
      ],
      selecionarTodos: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      auxUsuario: {},
      usuariosSelecionados: []
    };
  },
  watch: {
    'relatorio.administradora': function(newValue, oldValue){
      if(newValue !== oldValue){
        this.condominiosDisponiveis = []
        this.relatorio.condominio = {}
      }
    },
    'relatorio.statusSelecionadosImovel': function(newValue){
      if(newValue.length === this.opcoesStatusImoveis.length){
        this.selecionarTodos = true;
      }else{
         this.selecionarTodos = false;
      }
    },
    'relatorio.statusSelecionadosPlaca': function(newValue){
      if(newValue.length === this.opcoesStatusPlacas.length){
        this.selecionarTodosPlacas = true;
      }else{
         this.selecionarTodosPlacas = false;
      }
    }
  },
  created() {
    if(this.permissoes && this.permissoes.relatorioImoveisCaptadosPorCaptador){ this.tiposRelatorios.push({ label: "Imóveis Captados Por Captador", value: "IMOVEIS_CAPTACAO_CAPTADOR" }) }
    if(this.permissoes && this.permissoes.relatorioImoveisCaptadosPorTipoDeImovel){ this.tiposRelatorios.push({ label: "Imóveis Captados Por Tipo de Imóvel", value: "IMOVEIS_CAPTACAO_TIPO_IMOVEL" }) }
    this.tiposRelatorios.push({label: "Ficha de Imóvel", value: "IMOVEIS_FICHA" })
    if(this.permissoes && this.permissoes.relatorioImoveisParaAluguel){ this.tiposRelatorios.push({ label: "Imóveis para Aluguel", value: "IMOVEIS_ALUGUEL" }) }
    if(this.permissoes && this.permissoes.relatorioImoveisAluguelPorTipoDeImovel){ this.tiposRelatorios.push({ label: "Imóveis para Aluguel Por Tipo de Imóvel", value: "IMOVEIS_ALUGUEL_POR_TIPO_IMOVEL" }) }
    if(this.permissoes && this.permissoes.relatorioImoveisPorCliente){ this.tiposRelatorios.push({ label: "Imóveis por Cliente", value: "IMOVEIS_POR_CLIENTE" }) }
    if(this.permissoes && this.permissoes.relatorioImoveisPorCondominio){ this.tiposRelatorios.push({ label: "Imóveis por Condomínio", value: "IMOVEIS_POR_CONDOMINIO" }) }
    if(this.permissoes && this.permissoes.relatorioImoveisComPlaca){ this.tiposRelatorios.push({ label: "Imóveis com Placa", value: "IMOVEIS_COM_PLACA" }) }
    if(this.permissoes && this.permissoes.relatorioImoveisSemPlaca){ this.tiposRelatorios.push({ label: "Imóveis sem Placa", value: "IMOVEIS_SEM_PLACA" }) }
    if(this.permissoes && this.permissoes.relatorioImoveisSemFotos){ this.tiposRelatorios.push({ label: "Imóveis sem Foto", value: "IMOVEIS_SEM_FOTO" }) }
    if(this.permissoes && this.permissoes.relatorioImoveisReservados){ this.tiposRelatorios.push({ label: "Imóveis Reservados", value: "IMOVEIS_RESERVADOS" }) }
    if(this.permissoes && this.permissoes.relatorioImoveisPublicadosSite){ this.tiposRelatorios.push({ label: "Imóveis Publicados no Site", value: "IMOVEIS_PUBLICADOS_SITE" }) }
    if(this.permissoes && this.permissoes.relatorioImoveisAcompanhamento) { this.tiposRelatorios.push({ label: "Imóveis com E-mail de Acompanhamento", value: "IMOVEIS_ACOMPANHAMENTO" }) }
    if(this.permissoes && this.permissoes.relatorioMatriculasImoveis){ this.tiposRelatorios.push({ label: "Matrículas dos Imóveis", value: "MATRICULAS_IMOVEIS" }) }
    if(this.permissoes && this.permissoes.relatorioResumoAdministradoras){ this.tiposRelatorios.push({ label: "Resumo das Administradoras", value: "RESUMO_ADMINISTRADORAS" }) }
    if(this.permissoes && this.permissoes.relatorioVisitasPorPeriodo){ this.tiposRelatorios.push({ label: "Visitas por Período", value: "VISITAS_POR_PERIODO" }) }
    if(this.permissoes && this.permissoes.relatorioVistoriasPorPeriodo){ this.tiposRelatorios.push({ label: "Vistorias por Período", value: "VISTORIAS_POR_PERIODO" }) }
    this.tiposRelatorios.push({label: "Vacância dos Imóveis", value: "IMOVEIS_VACANCIA" })
    this.tiposRelatorios.push({label: "Tempo de Negociação dos Imóveis", value: "IMOVEIS_TEMPO_NEGOCIACAO" })
  },
  computed: {
    ...mapState("loginStore", {
      //usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "RELATORIOS_IMOVEIS_ALUGUEL" })[0] }
    }),
    ...mapState("alugueisRelatoriosStore", {
      usuariosDisponiveis(state) {
        return state.usuariosDisponiveis;
      },
      clientesDisponiveis(state) {
        return state.clientesDisponiveis;
      }
    }),
    // VISIBILIDADE CAMPOS
    exibirTipoImovel(){
      return (
        this.relatorio.nome === 'IMOVEIS_CAPTACAO_CAPTADOR' ||
        this.relatorio.nome === 'IMOVEIS_CAPTACAO_TIPO_IMOVEL' ||
        this.relatorio.nome === 'IMOVEIS_ALUGUEL' ||
        this.relatorio.nome === 'IMOVEIS_ALUGUEL_POR_TIPO_IMOVEL' ||
        this.relatorio.nome === 'IMOVEIS_COM_PLACA' ||
        this.relatorio.nome === 'IMOVEIS_SEM_PLACA' ||
        this.relatorio.nome === 'MATRICULAS_IMOVEIS'
        )
    },
    exibirFiltroDataPlaca(){
      return (
        this.relatorio.nome === 'IMOVEIS_COM_PLACA' ||
        this.relatorio.nome === 'IMOVEIS_SEM_PLACA'
        )
    },
    exibirDataColocacaoPlaca(){
      return this.relatorio.nome === 'IMOVEIS_COM_PLACA'
    },
    exibirStatusPlaca(){
      return this.relatorio.nome === 'IMOVEIS_COM_PLACA'
    },
    opcoesStatusPlacas(){
      return [
        {label: "Instalada", data: "COLOCADA"},
        {label: "Retirada", data: "RETIRADA"},
        {label: "Extraviada", data: "EXTRAVIADA"}
      ];
    },
    exibirPeriodo(){
      return (
        this.relatorio.nome === 'IMOVEIS_CAPTACAO_CAPTADOR' ||
        this.relatorio.nome === 'IMOVEIS_CAPTACAO_TIPO_IMOVEL' ||
        this.relatorio.nome === 'IMOVEIS_ALUGUEL' || this.relatorio.nome === 'IMOVEIS_ALUGUEL_POR_TIPO_IMOVEL' ||
        (this.relatorio.nome === 'IMOVEIS_COM_PLACA' && this.relatorio.dataPlaca !== 'SEM_FILTRO') ||
        (this.relatorio.nome === 'IMOVEIS_SEM_PLACA' && this.relatorio.dataPlaca !== 'SEM_FILTRO') ||
        this.relatorio.nome === 'IMOVEIS_SEM_FOTO' ||
        this.relatorio.nome === 'IMOVEIS_RESERVADOS' ||
        (this.relatorio.nome === 'MATRICULAS_IMOVEIS' && this.relatorio.statusSelecionadosImovel.includes("LOCADO")) ||
        this.relatorio.nome === 'VISITAS_POR_PERIODO' ||
        this.relatorio.nome === 'VISTORIAS_POR_PERIODO' || 
        this.relatorio.nome === 'IMOVEIS_VACANCIA' || 
        this.relatorio.nome === 'IMOVEIS_TEMPO_NEGOCIACAO'
        )
    },
    isVisibleFiltroValor() {
      return this.relatorio.nome === 'IMOVEIS_CAPTACAO_TIPO_IMOVEL';
    },
    exibirDiasCadastrado(){
      return (this.relatorio.nome === 'IMOVEIS_ALUGUEL' || this.relatorio.nome === 'IMOVEIS_ALUGUEL_POR_TIPO_IMOVEL') 
      && this.relatorio.statusSelecionadosImovel.includes('DISPONIVEL') && this.relatorio.statusSelecionadosImovel.length === 1
    },
    labelPeriodo(){
      return this.relatorio.nome === 'IMOVEIS_TEMPO_NEGOCIACAO' || this.relatorio.nome === 'IMOVEIS_TEMPO_NEGOCIACAO' ? 'Período de Captação' :
      'Período';
    },
    exibirStatus(){
      return (
        this.relatorio.nome === 'IMOVEIS_CAPTACAO_CAPTADOR' ||
        this.relatorio.nome === 'IMOVEIS_CAPTACAO_TIPO_IMOVEL' ||
        this.relatorio.nome === 'IMOVEIS_ALUGUEL' ||
        this.relatorio.nome === 'IMOVEIS_ALUGUEL_POR_TIPO_IMOVEL' ||
        this.relatorio.nome === 'IMOVEIS_POR_CLIENTE' ||
        this.relatorio.nome === 'IMOVEIS_POR_CONDOMINIO' ||
        this.relatorio.nome === 'IMOVEIS_COM_PLACA' ||
        this.relatorio.nome === 'IMOVEIS_SEM_PLACA' ||
        this.relatorio.nome === 'IMOVEIS_SEM_FOTO' ||
        this.relatorio.nome === 'MATRICULAS_IMOVEIS' || 
        this.relatorio.nome === 'IMOVEIS_VACANCIA' || 
        this.relatorio.nome === 'IMOVEIS_TEMPO_NEGOCIACAO'
        );
    },
    exibirFaxaDiasFiltro(){
      return (
        this.relatorio.nome === 'IMOVEIS_VACANCIA' || 
        this.relatorio.nome === 'IMOVEIS_TEMPO_NEGOCIACAO'
      );
    },
    exibirCliente(){
      return (
        this.relatorio.nome === 'IMOVEIS_POR_CLIENTE' ||
        this.relatorio.nome === 'IMOVEIS_RESERVADOS' ||
        this.relatorio.nome === 'MATRICULAS_IMOVEIS'
        )
    },
    exibirEstadoCidadeBairro(){
      return (
        this.relatorio.nome === 'IMOVEIS_ALUGUEL' || this.relatorio.nome === 'IMOVEIS_ALUGUEL_POR_TIPO_IMOVEL'
        )
    },
    exibirAdministradora(){
      return (
        this.relatorio.nome === 'IMOVEIS_POR_CONDOMINIO' ||
        this.relatorio.nome === 'RESUMO_ADMINISTRADORAS'
        )
    },
    exibirEdificioCondominio(){
      return (
        this.relatorio.nome === 'IMOVEIS_POR_CONDOMINIO'|| 
        this.relatorio.nome === 'IMOVEIS_VACANCIA' || 
        this.relatorio.nome === 'IMOVEIS_TEMPO_NEGOCIACAO'
      )
    },
    exibirCorretor(){
      return (
        this.relatorio.nome === 'IMOVEIS_RESERVADOS' ||
        this.relatorio.nome === 'VISITAS_POR_PERIODO' ||
        this.relatorio.nome === 'VISTORIAS_POR_PERIODO' ||
        this.relatorio.nome === 'IMOVEIS_CAPTACAO_CAPTADOR' || 
        this.relatorio.nome === 'IMOVEIS_FICHA'
        )
    },
    exibirTipoVistoria() {
      return this.relatorio.nome === 'VISTORIAS_POR_PERIODO';
    },
    exibirStatusVistoria() {
      return this.relatorio.nome === 'VISTORIAS_POR_PERIODO';
    },
    exibirDataAgendamento() {
      return this.relatorio.nome === 'VISTORIAS_POR_PERIODO';
    },
    exibirDataConclusao() {
      return this.relatorio.nome === 'VISTORIAS_POR_PERIODO';
    },
    
    // UTIL
    tiposImoveis() { return TIPOS_IMOVEIS },
    estados() { return ESTADOS },
    tiposVistoria() { return TIPO_VISTORIA },
    statusVistoria() { return STATUS_VISTORIA },
    opcoesStatusImoveis(){
      let nomesRelatorios = ["IMOVEIS_VACANCIA", "IMOVEIS_TEMPO_NEGOCIACAO"]
      return [
        {label: "Disponível", data: "DISPONIVEL"},
        {label: "Reservado", data: "RESERVADO"},
        {label: "Indisponível", data: "INDISPONIVEL"},
        {label: "Locado", data: "LOCADO"},
        !nomesRelatorios.includes(this.relatorio.nome) && {label: "Em Desocupação", data: "EM_DESOCUPACAO"},
        !nomesRelatorios.includes(this.relatorio.nome) && {label: "Arquivado", data: "ARQUIVADO"},
        !nomesRelatorios.includes(this.relatorio.nome) && {label: "Excluído", data: "EXCLUIDO"}
      ].filter(Boolean);
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisRelatoriosStore", [
      "gerarRelatorio",
      "listarUsuarios",
      "listarClientes",
      "listarImoveis"
    ]),
    ...mapActions("administradorasStore", ['listarAdministradoras']),
    ...mapActions("condominiosStore", ['pesquisarCondominios']),   
    ...mapActions("cidadesStore", ["listarCidades"]),
    ...mapActions("bairrosStore", ["listarBairros"]),

    onOpen() {
      this.relatorio.nome = undefined;
      this.relatorio.xls = false;
    },
    alterarStatusTodos(){
      if(this.selecionarTodos){
        this.relatorio.statusSelecionadosImovel = this.opcoesStatusImoveis.map(item => item.data);
      }else{
        this.relatorio.statusSelecionadosImovel = []
      }
    },

    alterarStatusTodosPlacas(){
      if(this.selecionarTodosPlacas){
        this.relatorio.statusSelecionadosPlaca = this.opcoesStatusPlacas.map(item => item.data);
      }else{
        this.relatorio.statusSelecionadosPlaca = []
      }
    },

    ajustarPayloadRelatorio(relatorio) {
      // Remove campos desnecessários de acordo com o relatório
      
      const payload = Object.assign({}, relatorio);
      const relatoriosQueUsamDatas = [
        'IMOVEIS_CAPTACAO_CAPTADOR',
        'IMOVEIS_CAPTACAO_TIPO_IMOVEL',
        'IMOVEIS_ALUGUEL',
        'IMOVEIS_ALUGUEL_POR_TIPO_IMOVEL',
        'IMOVEIS_COM_PLACA',
        'IMOVEIS_SEM_PLACA',
        'IMOVEIS_SEM_FOTO',
        'IMOVEIS_RESERVADOS',
        'VISITAS_POR_PERIODO',
        'VISTORIAS_POR_PERIODO',
        'IMOVEIS_VACANCIA',
        'IMOVEIS_TEMPO_NEGOCIACAO'
      ];
      const relatorioNaoUsaData = !relatoriosQueUsamDatas.includes(payload.nome);
      
      if(relatorioNaoUsaData) {
        delete payload.dataInicial;
        delete payload.dataFinal;
      }

      const relatoriosQueUsamCliente = [
        'IMOVEIS_POR_CLIENTE',
        'IMOVEIS_RESERVADOS',
        'MATRICULAS_IMOVEIS'
      ];
      const relatorioNaoUsaCliente = !relatoriosQueUsamCliente.includes(payload.nome);

      if(relatorioNaoUsaCliente) {
        delete payload.cliente;
      }

      if(payload.nome !== "IMOVEIS_ALUGUEL" && payload.nome !== 'IMOVEIS_ALUGUEL_POR_TIPO_IMOVEL') {
        delete payload.estado;
        delete payload.cidade;
        delete payload.bairro;
      } else {
        delete payload.cliente;
        delete payload.imovel;
      }

      if (!this.filtroDataCaptacao && payload.nome !== 'IMOVEIS_COM_PLACA') {
        delete payload.dataInicial;
        delete payload.dataFinal;
      }

      if(payload.nome === 'IMOVEIS_COM_PLACA') {
        if(payload.dataPlaca === 'COLOCACAO') {
          payload.dataColocacaoInicial = payload.dataInicial;
          payload.dataColocacaoFinal = payload.dataFinal;

          delete payload.dataInicial;
          delete payload.dataFinal;
        } else if (payload.dataPlaca === 'RETIRADA') {
          payload.dataRemocaoInicial = payload.dataInicial;
          payload.dataRemocaoFinal = payload.dataFinal;

          delete payload.dataInicial;
          delete payload.dataFinal;
        }

        if(this.selecionarTodosPlacas) {
          delete payload.statusSelecionadosPlaca;
        }
      }

      if(payload.nome === 'IMOVEIS_COM_PLACA' || payload.nome === 'IMOVEIS_SEM_PLACA') {
        if(payload.dataPlaca === 'SEM_FILTRO') {
          delete payload.dataInicial;
          delete payload.dataFinal;
        }
      }

      delete payload.dataPlaca;
      //status dos imoveis
      if(this.selecionarTodos){
        delete payload.statusSelecionadosImovel;
      }
      if(
        payload.nome === 'IMOVEIS_CAPTACAO_CAPTADOR' ||
        payload.nome === 'IMOVEIS_CAPTACAO_TIPO_IMOVEL' ||
        payload.nome === 'IMOVEIS_COM_PLACA' ||
        payload.nome === 'IMOVEIS_SEM_PLACA' ||
        payload.nome === 'MATRICULAS_IMOVEIS'
      ) {
          payload.imovel.tipoImovel = payload.tipoImovel;
          delete payload.tipoImovel;
      }

      if(payload.nome === 'IMOVEIS_CAPTACAO_TIPO_IMOVEL') {
        payload.imovel.valorInicial = payload.valorInicial;
        payload.imovel.valorFinal = payload.valorFinal;
        delete payload.valorInicial;
        delete payload.valorFinal;
      }

      if(payload.nome != 'IMOVEIS_FICHA'){
        delete payload.modulo;
      }

      return payload;
    },

    gerarRelatorioHandler() {
      if(this.relatorio.nome === 'IMOVEIS_POR_CLIENTE') {
        if(!this.relatorio.cliente || this.relatorio.cliente.id === 0) {
          this.$message.warning('Selecione um Cliente');
          return;
        }
      }

      if(this.relatorio.nome === 'IMOVEIS_COM_PLACA') {
        if(this.relatorio.dataPlaca === 'CAPTACAO' || this.relatorio.dataPlaca === 'COLOCACAO' || this.relatorio.dataPlaca === 'RETIRADA') {
          const dataInicialNaoEValida = !funcoes.validarData(this.relatorio.dataInicial);
          const dataFinalNaoEValida = !funcoes.validarData(this.relatorio.dataFinal);

          if(dataInicialNaoEValida || dataFinalNaoEValida) {
            this.$message.warning('Selecione uma data válida');
            return;
          }
        }

        if(this.relatorio.statusSelecionadosPlaca && this.relatorio.statusSelecionadosPlaca.length === 0) {
          this.$message.warning('Selecione pelo menos um Status da Placa');
          return;
        }
      }

      if(this.relatorio.nome === 'IMOVEIS_SEM_PLACA') {
        if(this.relatorio.dataPlaca === 'CAPTACAO') {
          const dataInicialNaoEValida = !funcoes.validarData(this.relatorio.dataInicial);
          const dataFinalNaoEValida = !funcoes.validarData(this.relatorio.dataFinal);

          if(dataInicialNaoEValida || dataFinalNaoEValida) {
            this.$message.warning('Selecione uma data válida');
            return;
          }
        }
      }

      if(this.relatorio.nome === 'VISITAS_POR_PERIODO') {
        const dataInicialNaoEValida = !funcoes.validarData(this.relatorio.dataInicial);
        const dataFinalNaoEValida = !funcoes.validarData(this.relatorio.dataFinal);

        if(dataInicialNaoEValida || dataFinalNaoEValida) {
          this.$message.warning('Selecione uma data válida');
          return;
        }
      }

      if(this.relatorio.nome === 'VISTORIAS_POR_PERIODO') {
        const dataInicialNaoEValida = !funcoes.validarData(this.relatorio.dataInicial);
        const dataFinalNaoEValida = !funcoes.validarData(this.relatorio.dataFinal);

        if(dataInicialNaoEValida || dataFinalNaoEValida) {
          this.$message.warning('Selecione uma data válida');
          return;
        }
      }

      if(this.exibirStatus && (this.relatorio.statusSelecionadosImovel.length === 0)){
        this.$message.warning('Selecione pelo menos um Status');
          return;
      }
      
      this.gerar();
    },

    gerar() {
      const payload = this.ajustarPayloadRelatorio(this.relatorio);

      this.showLoading();
      this.gerarRelatorio(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              window.open(resultado.mensagem, "_blank");
              break;
            case "FALHA":
              this.$message.warning('Não foi possível gerar o relatório');
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },

    // SELECTS
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString };
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      });
    },
    filtrarClientesSelect(queryString) {
      let payload = {};

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

      this.loadingClientes = true;
      this.listarClientes(payload)
        .then(() => {
          this.loadingClientes = false;
        })
    },
    recuperarAdministradorasSelect(queryString) {
      let payload = { nome: queryString };
      
      this.loadingAdministradoras = true;
      this.listarAdministradoras(payload)
      .then((resultado) => {
        this.administradorasDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
        this.loadingAdministradoras = false;
      });
    },
    recuperarCondominiosSelect(queryString) {
      let payload = { nome: queryString };

      if(this.relatorio.administradora && this.relatorio.administradora.id !== 0) {
        payload.administradora = this.relatorio.administradora
      }
      
      this.loadingCondominios = true;
      this.pesquisarCondominios(payload)
      .then((resultado) => {
        this.condominiosDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
        this.loadingCondominios = false;
      });
    },
    recuperarCidadesSelect(queryString) {
      if(this.relatorio.estado.id === 0) {
        this.$message.warning("Selecione o estado");
        return;
      }
      let payload = { nome: queryString, estado: { id: this.relatorio.estado.id } };
      
      this.loadingCidades = true;
      this.listarCidades(payload)
      .then((resultado) => {
        this.loadingCidades = false;
        this.cidadesDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
      }).catch(() => {
        this.loadingCidades = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    recuperarBairrosSelect(queryString) {
      if(this.relatorio.cidade.id === 0) {
        this.$message.warning("Selecione a cidade");
        return;
      }
      let payload = { nome: queryString, cidade: { id: this.relatorio.cidade.id } };

      this.loadingBairros = true;
      this.listarBairros(payload)
      .then((resultado) => {
        this.loadingBairros = false;
        this.bairrosDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
      }).catch(() => {
        this.loadingBairros = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    // UTIL
    formatarSelectCliente(cliente){
      return funcoes.formatarSelectCliente(cliente);
    },
    limparFiltros() {
      this.relatorio = {
        nome: this.relatorio.nome,
        usuario: {
          perfil: undefined
        },
        modulo: 'ALUGUEL',
        statusSelecionadosImovel: ['DISPONIVEL'],
        tipoImovel: undefined,
        cliente: {id: 0},
        imovel: { operacao: 'ALUGUEL' },
        estado: {id: 0},
        cidade: {id: 0},
        bairro: {id: 0},
        xls: this.relatorio.xls,
        administradora: undefined,
        condominio: undefined,
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        dataPlaca: 'CAPTACAO',
        statusSelecionadosPlaca: ['COLOCADA']
      },
      this.selecionarTodos = false;
      this.selecionarTodosPlacas = false;
    },
    adicionarUsuarioSelecionado() {
      this.usuariosSelecionados.push(this.auxUsuario);
    },
    removerUsuarioSelecionado(usuario) {
      var i;
      for (i = 0; i < this.usuariosSelecionados.length; i++) {
        if (this.usuariosSelecionados[i].id == usuario.id) {
          this.usuariosSelecionados.splice(i, 1);
        }
      }
    },
    fechar() {
      this.$emit("close");
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    }
  }
};
</script>

<style scoped>
.form-item {
  width: 100%;
}
.select {
  font-size: 50%;
}
.radio-align-column{
  display: grid;
  grid-template-columns: repeat(4, auto);
  gap: 5px 5px;
  align-items: center;
}
</style>